import React from 'react';
import styled from 'styled-components';
import { PALETTE } from '~/assets/styles/base';

type WrapperProps = {
  $marginTop: string;
};
const Wrapper = styled.div<WrapperProps>`
  width: 560px;
  margin: ${({ $marginTop }) => `${$marginTop} auto`};
  box-shadow: 0px 3px 6px #00000029;
`;

const AlertHead = styled.div`
  background-color: #e26666;
  min-height: 46px;
  line-height: 46px;
  padding: 0 22px;
  color: #fff;
  display: flex;
  align-items: center;
`;

const AlertBody = styled.div`
  border: 1px solid #e26666;
  border-top: 0px;
  background: #fff;
  padding: 19px 22px;
  font-size: 1.6rem;
  line-height: 1.5;
  color: ${PALETTE.error.main};
`;

type Props = {
  head: JSX.Element | string;
  body: JSX.Element | string;
  marginTop: string;
};

const Alert: React.FC<Props> = ({ head, body, marginTop }): JSX.Element => (
  <Wrapper $marginTop={marginTop} data-testid="uiParts-Alert">
    <AlertHead>{head}</AlertHead>
    <AlertBody>{body}</AlertBody>
  </Wrapper>
);

export default Alert;
